import { Injectable, Inject } from '@angular/core';
import { ENV_CONFIG } from 'src/app/core/injection.token';
import { ApiService } from 'src/app/core/services/api.service';
import { DocumentExport } from './events';

@Injectable()
export class DocumentExportAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'documentExport';

  public exportInvoices(pageFilters: any, client: any) {
    const request = 'exportInvoices';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    const body = {
      clientId: client.uniqueIdentifier,
      clientName: client.name,
      startDate: pageFilters.startDate,
      endDate: pageFilters.endDate,
      categories: pageFilters.categories,
      isPaid: pageFilters.isPaid,
      isNotPaid: pageFilters.isNotPaid,
      isOverdue: pageFilters.isOverdue,
      contracts: pageFilters.contracts,
      isOther: pageFilters.isOther,
      withoutContract: pageFilters.withoutContract,
      contractTypeCodes: pageFilters.contractTypeCodes,
    };

    return this._apiService.postAsync<any>(url, body, []);
  }

  public exportPayments(client: any, pageFilters: any) {
    const request = 'exportPayments';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    const body = {
      startDate: pageFilters.startDate,
      endDate: pageFilters.endDate,
      clientId: client.uniqueIdentifier,
      clientName: client.name,
    };

    return this._apiService.postAsync<any>(url, body, []);
  }

  public exportContractPaymentSchedule(contractId: string, exportAs: string) {
    const request = 'exportContractPaymentSchedule';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    const body = {
      contractId: contractId,
      exportAs: exportAs,
    };

    return this._apiService.postAsync<app.models.ServerResponseModel>(
      url,
      body,
      [DocumentExport.ContractPaymentScheduleExported, DocumentExport.ContractPaymentScheduleFileSaved],
      [DocumentExport.ContractPaymentScheduleFileSaved],
      [DocumentExport.ContractPaymentScheduleExportFailed, DocumentExport.ContractPaymentScheduleFileSaveFailed]
    );
  }

  public exportSpecialOffer(specialOfferId: string) {
    const request = 'exportSpecialOffer';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    const body = {
      specialOfferId: specialOfferId,
    };

    return this._apiService.postAsync<any>(url, body, []);
  }
}
